import React, { useEffect } from "react";
import { Modal, Button, Switch, Checkbox, Divider, List } from "antd";
import { ArrowLeftOutlined, CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setIsEditpopup } from "../../redux/slices/popUpSlice";
import "./activateDeactivate.scss";
import Loading from "../Loader/Loading";
import { CaretRightFilled, CaretDownFilled } from "@ant-design/icons";

const ActiveDeactive = ({
  onClose,
  addNewRole,
  setAddNewRole,
  setUserData,
  setOpen,
  handleSubmit,
  isEdit,
  goBack,
}) => {
  const [isChecked, setChecked] = React.useState({});
  const [isDropdownOpen, setIsDropdownOpen] = React.useState({});
  const [isAnyMethodSelected, setIsAnyMethodSelected] = React.useState(false);
  const { isActivatePopup, isEditActivate } = useSelector(
    (state) => state.popUpRedducer
  );
  const dispatch = useDispatch();
  const getPermission = useSelector(
    (state) => state.userManagementReducer.getAllPermission
  );
  const { loading } = useSelector((state) => state.userManagementReducer);
  const { invalidPermissions } = useSelector((state) => state.userRoleReducer);
  const handleDropdownClick = (label) => {
    setIsDropdownOpen((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handleSwitchChange = (label) => {
    setChecked((prev) => {
      const currentState = !!prev[label];
      const newState = !currentState;
      const updatedChecked = newState ? { ...prev[label] } : {};

      setAddNewRole((prevRole) => {
        const updatedPermissions = { ...prevRole.permissions };
        if (newState) {
          updatedPermissions[label] =
            updatedPermissions[label] || Object.keys(updatedChecked);
        } else {
          delete updatedPermissions[label];
        }
        return {
          ...prevRole,
          name: addNewRole?.name,
          permissions: updatedPermissions,
        };
      });

      setUserData((prevData) => {
        const updatedPermissions = { ...prevData.permissions };
        if (newState) {
          updatedPermissions[label] =
            updatedPermissions[label] || Object.keys(updatedChecked);
        } else {
          delete updatedPermissions[label];
        }
        return {
          ...prevData,
          permissions: updatedPermissions,
        };
      });

      return {
        ...prev,
        [label]: updatedChecked,
      };
    });

    setIsDropdownOpen((prev) => ({
      ...prev,
      [label]: !isChecked[label],
    }));
  };

  const handleClose = () => {
    onClose();
    dispatch(setIsEditpopup(false));
  };

  const handleChange = (label, method) => (event) => {
    const { checked } = event.target;

    setChecked((prev) => ({
      ...prev,
      [label]: {
        ...prev[label],
        [method]: checked,
      },
    }));

    setAddNewRole((prev) => {
      const updatedPermissions = { ...prev.permissions };

      if (checked) {
        updatedPermissions[label] = updatedPermissions[label]
          ? [...updatedPermissions[label], method]
          : [method];
      } else {
        updatedPermissions[label] = updatedPermissions[label]?.filter(
          (item) => item !== method
        );
      }

      return {
        ...prev,
        name: addNewRole?.name,
        permissions: updatedPermissions,
      };
    });
    setUserData((prev) => {
      const updatedPermissions = { ...prev.permissions };

      if (checked) {
        updatedPermissions[label] = updatedPermissions[label]
          ? [...updatedPermissions[label], method]
          : [method];
      } else {
        updatedPermissions[label] = updatedPermissions[label]?.filter(
          (item) => item !== method
        );
      }

      return {
        ...prev,
        permissions: updatedPermissions,
      };
    });
  };

  useEffect(() => {
    if (addNewRole) {
      const initialCheckedState = {};
      for (const [label, methods] of Object.entries(addNewRole?.permissions)) {
        initialCheckedState[label] = {};
        methods.forEach((method) => {
          initialCheckedState[label][method] = true;
        });
      }
      setChecked(initialCheckedState);
    }
  }, [addNewRole]);

  const SwitchSection = ({ label, methods }) => {
    const isAnyMethodSelected = Object.values(isChecked[label] || {}).some(
      Boolean
    );

    return (
      <div style={{ marginTop: "16px" }}>
        {loading ? (
          <Loading />
        ) : (
          <List bordered size="large">
            <div style={{ padding: "15px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    onClick={() => handleDropdownClick(label)}
                    style={{ marginRight: "8px", cursor: "pointer" }}
                  >
                    {isDropdownOpen[label] ? (
                      <CaretDownFilled />
                    ) : (
                      <CaretRightFilled />
                    )}
                  </div>
                  <div>{label}</div>
                </div>
                <Switch
                  className="switch-icon"
                  checked={!!isChecked[label]}
                  onChange={() => handleSwitchChange(label)}
                />
              </div>
              {isDropdownOpen[label] && (
                <List.Item className="checkbox-icon">
                  {methods?.map((method, index) => (
                    <List.Item key={index} style={{ display: "flex" }}>
                      <Checkbox
                        checked={isChecked[label] && isChecked[label][method]}
                        onChange={handleChange(label, method)}
                        value={method}
                      />
                      <span style={{ marginLeft: "5px" }}>{method}</span>
                    </List.Item>
                  ))}
                </List.Item>
              )}
              {invalidPermissions[label] && (
                <div className="permission-error">
                  Cannot add permission
                  {invalidPermissions[label].length !== 1 ? "s" : ""}{" "}
                  {invalidPermissions[label].join(",")} in {label}
                </div>
              )}
            </div>
          </List>
        )}
      </div>
    );
  };

  const handleBackArrow = () => {
    goBack();
  };

  useEffect(() => {
    const anySelected = Object.values(isChecked).some((section) =>
      Object.values(section).some((checked) => checked)
    );
    setIsAnyMethodSelected(anySelected);
  }, [isChecked]);

  const renderFooter = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Button onClick={handleClose}>Cancel</Button>
      <Button
        type="primary"
        onClick={isAnyMethodSelected ? handleSubmit : null}
        disabled={!isAnyMethodSelected}
        style={{
          backgroundColor: isAnyMethodSelected ? "#8176f2" : "#c4c4c4",
          borderColor: isAnyMethodSelected ? "#8176f2" : "#c4c4c4",
          color: "white",
        }}
      >
        Submit
      </Button>
    </div>
  );

  return (
    <Modal
      open={isEdit ? isEdit : isActivatePopup}
      onCancel={handleClose}
      footer={renderFooter()}
      closable={false}
      onOk={handleClose}
      width={600}
      styles={{
        body: {
          maxHeight: "65vh",
          overflow: "hidden"
        },
      }}
      title={
        isEditActivate ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ArrowLeftOutlined
              style={{ cursor: "pointer" }}
              onClick={handleBackArrow}
            />
            <div>Edit User Permissions</div>
            <div>
              <CloseOutlined
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        ) : (
          `Add User Permissions`
        )
      }
    >
      {Object.entries(getPermission).map(([section, methods], index) => (
        <SwitchSection key={index} label={section} methods={methods} />
      ))}
      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "1.5rem",
        }}
      ></div>
    </Modal>
  );
};

export default ActiveDeactive;
